import * as S from "./styles.ts";
import { HexColorPicker } from "react-colorful";

const ColorPicker = ({
  color,
  onChange,
}: {
  color: string;
  onChange: (color: string) => void;
}) => {
  return (
    <S.ColorPickerWrapper>
      <S.ColorPickerContainer>
        <HexColorPicker
          color={color}
          onChange={onChange}
        />
      </S.ColorPickerContainer>
    </S.ColorPickerWrapper>
  );
};

export default ColorPicker;
